import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IReceptionDetailViewModel } from '../../../../models/reception';
import { namespace } from 'vuex-class';
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_LOADERS } from '../../../../store/reception/reception-types.store';

const ReceptionStore= namespace(RECEPTION_MODULE_NAMESPACE)

@Component({
  components:{
    'reception-details-loader' : async () => import('../../loaders/reception-details-loader/ReceptionDetailsLoader.vue')
  }
})
class MHReceptionChildDetailGeneralInfo extends Vue {

  @Prop({
    default: () => ({
      block: { name: '' },
      apartment: { apartment_number: '', location_number: null },
      customer: { firstname: '', lastname: '' }
    }), type: [Object]
  })
  reception: IReceptionDetailViewModel
  /**
   *
   */
  constructor() {
    super();
  }

  @ReceptionStore.Getter loaders: Map<string,boolean>

  get lblSetting() {
    return {
      ...require('@/locales/reception').default,
    }
  }
  get blockName(): string {
    return this.reception.block.name;
  }
  get coLoader(): boolean {
    return this.loaders.get(RECEPTION_LOADERS.DETAILS)
  }

  getEntityName(entity: { firstname: string, lastname: string }) {
    return [entity.firstname, entity.lastname].join(' ')
  }
  get declarantName(): string {
    return [this.reception.createdBy.firstname, this.reception.createdBy.lastname].join(' ')
  }
  get apartmentNumber(): string {
    let apartmentInfo: string[] = [];
    if (this.reception.apartment.location_number) {
      apartmentInfo.push(this.reception.apartment.location_number)
    }
    apartmentInfo.push(this.reception.apartment.apartment_number)
    return apartmentInfo.join('/');
  }

  get vehicle(): string {
    if(!this.reception.vehicle) return null
    const {brand, name, reference} = this.reception.vehicle
    const nameArray = [brand, name, reference].filter(x=>x!==null && x!="")
    return nameArray.join(' - ')
  }
}

export default MHReceptionChildDetailGeneralInfo;



// WEBPACK FOOTER //
// ./src/containers/mh-reception/components/mh-reception-detail-general-info/index.ts